import {UPDATE_USER_LOCATION, SET_USER_LOCATION_LOAD, SET_USER_LOCATION_ERROR} from "../actions/UserLocation"

const defaultState = {
  userLocation: {
    latLng: {
      lat: null,
      lng: null
    },
    city: null,
    error: null,
    load: null,
    isFallback: null
  }
}

const GeoLocationReducer = (state = defaultState, action) => {
  switch (action.type) {
    case UPDATE_USER_LOCATION:
      return {
        ...state,
        userLocation: {
          ...state.userLocation,
          ...action.location
        }
      }
    case SET_USER_LOCATION_LOAD:
      return {...state, userLocation: {...state.userLocation, load: action.load}}
    case SET_USER_LOCATION_ERROR:
      return {...state, userLocation: {...state.userLocation, error: action.error}}
    default:
      return state
  }
}

export default GeoLocationReducer
